import request from "@/utils/request";

export default function monthlyTemplateAdd(data) {
    return request({
        url: `/device/monthlyTemplate/add`,
        method: 'post',
        data
    })
}
